/*************************************************/
/* SELECTED PRODUCTS SLIDER                      */
/*************************************************/
import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

export function selectedProductsSlider() {
    document.querySelectorAll(".selected-products--slider").forEach(root => {
        const swiperEl = root.querySelector(".selected-products__slider");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            modules: [Navigation, Scrollbar],
            speed: 500,
            slidesPerView: 1.15,
            spaceBetween: 15,
            watchOverflow: true,
            navigation: {
                nextEl: root.querySelector(".selected-products__nav-btn--next"),
                prevEl: root.querySelector(".selected-products__nav-btn--prev"),
            },
            scrollbar: {
                el: root.querySelector(".selected-products__scrollbar"),
                draggable: true,
            },
            breakpoints: {
                667: {
                    slidesPerView: 2.15,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    });
}
